import { render, staticRenderFns } from "./WeexImage.vue?vue&type=template&id=f824e46c&"
import script from "./WeexImage.vue?vue&type=script&lang=js&"
export * from "./WeexImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports